/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *	 var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *	 var variant = event.detail.variant; // Get the variant that was added
 *	 var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *	 bubbles: true
 * }));
 */
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

function jj_getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

$(document).on('click', '#sidebar-cart [name="checkout"], #shopping-cart [name="checkout"]', function(e) {
    var exp_cookie = jj_getCookie('dynamic_checkout_shown_on_cart');
    if (exp_cookie) {
        document.cookie = "dynamic_checkout_shown_on_cart=; expires= Thu, 01 Jan 1970 00:00:01 GMT;Path=/;";
    }
});

window.addEventListener('load', function() {
    let name = 'cookie-banner';
    let value = 'cookie-banner';
    let days = 90;
    let domain = document.domain;
    let cookieBanner = getCookie(name);

    // Use setInterval to check if customerPrivacy is defined
    let interval = setInterval(function () {
        if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.shouldShowBanner === 'function') {
            clearInterval(interval); // Stop checking once it's defined
            if (!cookieBanner && window.Shopify.customerPrivacy.shouldShowBanner() == false) {
                displayCookieBanner();
            }
        }
    }, 100); // Check every 100ms

    var cookie_element = document.getElementById('cookie-banner-close')
    if (cookie_element) {
        cookie_element.addEventListener('click', function(event) {
            event.preventDefault();

            if (!cookieBanner) {
                setCookie(name, value, days, domain);
            }

            hideCookieBanner();
        });
    }

    function hideCookieBanner() {
        if (document.getElementsByClassName('cookie-banner')) {
            document.getElementsByClassName('cookie-banner')[0].style.display = 'none';
        }
    }

    function displayCookieBanner() {
        if (document.getElementsByClassName(name)) {
            document.getElementsByClassName(name)[0].style.display = 'flex';
        }
    }

    function setCookie(name, value, days, domain) {
        let expires = "";
        let date = new Date();

        if (days) {
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }

        if (domain) {
            document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;
        } else {
            document.cookie = name + "=" + value + expires + "; path=/";
        }
    }

    function getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
});

$(document).ready(function() {

    $('.new-arrivals .MegaMenu__Item.MegaMenu__Item--fit').each(function(index) {
        $(this).remove();
    });

    $('.new-arrivals .MegaMenu__Inner').css("justify-content", "center");

    $(".has-submenu li a").each(function(i, v) {
        let transformedText = capitalizeFirstLetter($(v).text());
        $(v).text(transformedText);
    });

    $(document).on('click', "#open-modal [data-toggle='tab']", function() {
        var popup_section = $(this).data('section');
        $("#open-modal .nav-justified li").removeClass("active");
        $("#open-modal .tab-content .tab-pane").removeClass("active");

        $(this).parent("li").addClass("active");
        $("#open-modal .tab-content " + $(this).data("href")).addClass("active");

        if (typeof $.fn.lionbars !== 'undefined') {
            $('.size-chart--wrapper .TableWrapper').lionbars();
        }
    });

    $('.products-grid').slick();

    function expressCheckoutButtonLoader() {
        $('script#addition-checkout-custom').remove();
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.id = "addition-checkout-custom";
        s.src = "https://cdn.shopify.com/shopifycloud/payment-sheet/assets/latest/dynamic-checkout-cart.en.js?v=2";
        $("head").append(s);
    }

    jQuery(document).on('click', '[data-drawer-id="sidebar-cart"]', function() {
        if (jQuery.trim($('#sidebar-cart').find('#dynamic-checkout-cart').html()) == '') {
            expressCheckoutButtonLoader();
        }
    });

    document.addEventListener('theme:rerenderCart', function() {
        setTimeout(function() {
            if (jQuery.trim($('#sidebar-cart').find('#dynamic-checkout-cart').html()) == '') {
                $('script#addition-checkout-custom').remove();
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.id = "addition-checkout-custom";
                s.src = "https://cdn.shopify.com/shopifycloud/payment-sheet/assets/latest/dynamic-checkout-cart.en.js?v=2";
                $("head").append(s);
            }

            if ('undefined' !== typeof sr_$) {
                sr_$.renderDivs();
            }
        }, 100);


    });

    $("a.subscribe-button").click(function(e) {
        e.preventDefault();
        $.fancybox.close();
        var url = $(this).attr('href');

        if (url && url.indexOf("javascript") == -1) {
            $.fancybox.open({
                src: url,
                opts: {
                    type: 'iframe',
                    smallBtn: false,
                    touch: false,
                    afterLoad: function(instance, current) {
                        setTimeout(function() {
                            $(document).find('.fancybox-content').scrollTop(0);
                        }, 427);
                        $(document).find('.fancybox-content').addClass("subscribe-form");
                    }
                }
            });
        }
    });

    $(".other-payments > img").hide();
    $(".payment-option").show();

    /*
    $("body").on('DOMSubtreeModified', ".dynamic-checkout__content", function () {
        if ($('.dynamic-checkout__content').children().length > 0) {
            $(".other-payments > img").hide();
            $(".payment-option").show();
        } else {
            $(".other-payments > img").show();
            $(".payment-option").hide();
            expressCheckoutButtonLoader();
        }
    });
     */

});


$(document).ready(() => {
    $('.scrollToTop').click(() => {
        $('html, body').animate({
            scrollTop: 0
        }, 800);
        return false;
    });

    $(document).on('click', ".nav-tabs li a[data-toggle='tab']", function(e) {
        e.preventDefault();
        var popup_section = $(this).data('section');

        $(".size-chart--wrapper  ul." + popup_section + ".nav-justified li").each(function() {
            $(this).removeClass("active");
        })
        $(".size-chart--wrapper div." + popup_section + ".tab-content .tab-pane").each(function() {
            $(this).removeClass("active");
        });

        $(this).parent("li").addClass("active");
        //$(".size-chart--wrapper div." + popup_section + ".tab-content " + $(this).data("href")).addClass("active");

        var targetPane = $(".size-chart--wrapper div." + popup_section + ".tab-content " + $(this).data("href"));
        if (!targetPane.hasClass('active')) {
            targetPane.addClass("active");
        }
        
        $('html, body').animate({
            scrollTop:  $(e).offset().top
        }, 2000);
    });
});

// Fadein/Out scrolltop arrow
$(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
        $('.scrollToTop').fadeIn();
    } else {
        $('.scrollToTop').fadeOut();
    }
});

$(document).on('click', '.product-modal', function(e) {
    e.preventDefault();
    $.fancybox.close();
    var url = $(this).attr('data-href');
    if (!url) {
        url = $(this).attr('href');
    }

    if (window.location.href.split("?").length >= 2) {
        let href = window.location.href.split("?")[0];
        window.history.pushState({
            href: href
        }, '', href);
    }

    if (url) {
        $.fancybox.open({
            src: url,
            opts: {
                type: 'ajax',
                smallBtn: false,
                baseClass: "fancybox-skin",
                touch: false,
                afterLoad: function(instance, current) {
                    setTimeout(function() {
                        $(document).find('.fancybox-content').scrollTop(0);
                    }, 427);
                },
                beforeClose: function(e, instance) {
                    if (typeof window.languages.productFormAddToCartMain != 'undefined') {
                        window.languages.productFormAddToCart = window.languages.productFormAddToCartMain;
                    }
                }
            }
        });
    }

    return false;
});

$(document).ready(function() {
    let currentURL = window.location.href;
    let currentURLSplit = currentURL.split("?");
    let checkSize = null;
    let getSize = null;
    if (currentURLSplit.length > 1) {
        checkSize = currentURLSplit[1];
        if (checkSize.includes("size=")) {
            getSize = checkSize.replace("size=", "");
            getSize.split(",").map((x) => {
                $(".filter_holder.filter--size").find("input.size-" + x).attr("checked", "checked");
            })
            filter_data(true, getSize);
        }
    }
});

function short_desktop_data($data, $sort_by) {
    if ($sort_by == '') {
        var sort_by = $('#filter [name="sort"]:checked').val();
        if ($(window).width() < 1140) {
            var currentUrl = new URL(location.href);
            var sort_by = currentUrl.searchParams.get('sort_by');
        }
    } else {
        var sort_by = $sort_by;
    }

    if (sort_by == 'manual' || !sort_by) {
        return $data;
    }
    var fiter_data = jQuery($data).filter('.selected_filter').clone();
    var prefine_data = jQuery($data).filter('*:not(.selected_filter)').clone();
    var sortedOtherItems = '';

    if (prefine_data.find('.plp-tile').length > 0) {
        var filter_items = prefine_data.find('.plp-tile');
        var additionalContentBlock = filter_items.filter('.additional-content-block');
        var otherItems = prefine_data.find('.plp-tile:not(.additional-content-block)');
        if ('title-ascending' == sort_by) {
            sortedOtherItems = otherItems.sort(function(a, b) {
                var compA = $(a).data('title').toUpperCase();
                var compB = $(b).data('title').toUpperCase();
                return (compA > compB) ? 1 : -1;
            });
        } else if ('title-descending' == sort_by) {
            sortedOtherItems = otherItems.sort(function(a, b) {
                var compA = $(a).data('title').toUpperCase();
                var compB = $(b).data('title').toUpperCase();
                return (compA < compB) ? 1 : -1;
            });
        } else if ('price-ascending' == sort_by) {
            sortedOtherItems = otherItems.sort(function(a, b) {
                var compA = parseFloat($(a).data('price'));
                var compB = parseFloat($(b).data('price'));
                return (compA > compB) ? 1 : -1;
            });
        } else if ('price-descending' == sort_by) {
            sortedOtherItems = otherItems.sort(function(a, b) {
                var compA = parseFloat($(a).data('price'));
                var compB = parseFloat($(b).data('price'));
                return (compA < compB) ? 1 : -1;
            });
        } else if ('created-ascending' == sort_by) {
            sortedOtherItems = otherItems.sort(function(a, b) {
                var compA = $(a).data('date');
                var compB = $(b).data('date');
                return (compA > compB) ? 1 : -1;
            });
        } else if ('created-descending' == sort_by) {
            sortedOtherItems = otherItems.sort(function(a, b) {
                var compA = $(a).data('date');
                var compB = $(b).data('date');
                return (compA < compB) ? 1 : -1;
            });
        }
    }

    if (sortedOtherItems != '') {

        // Create an array to store the sorted elements
        var sortedItems = [];

        var i = 0;
        // Loop through the original 'filter_items' and add them to 'sortedItems' in the sorted order
        filter_items.each(function (index, element) {
            if ($(element).hasClass('additional-content-block')) {
                // If the element has the 'additional-content-block' class, add it to the sorted items
                sortedItems.push(additionalContentBlock[0]);
            } else {
                // For other elements, add them in the sorted order
                sortedItems.push(sortedOtherItems[i]);
                i++;
            }
        });

        // Create an empty array to store the sorted HTML strings
        var sortedHtmlStrings = [];

        // Loop through the sortedItems array and convert each element to an HTML string
        $.each(sortedItems, function (index, element) {
            sortedHtmlStrings.push(element.outerHTML);
        });

        // Combine the HTML strings into one string
        var sortedHtml = sortedHtmlStrings.join('');

        var d = $('<div/>').append(prefine_data);
        d.find('.ProductList.ProductList--grid').empty();
        d.find('.ProductList.ProductList--grid').append(sortedHtml);
        return (fiter_data.length > 0 ? $('<div/>').append(fiter_data).html() : '') + d.html();
    }

    return $data;
}

function filter_data($bypass, sizeValue = null) {

    jQuery('.filter_holder .inner-label').removeClass('sub--open');
    var data = sizeValue ? "" : $("#filter").serialize();

    if (data == "" && !$bypass) {
        return false;
    } else {
        var sort = "";
        var test = data.split("&");
        var filter_string = "";
        var sizes = "";
        var sort_by = '';
        for (var i = 0; i < test.length; i++) {
            var tmp1 = test[i].split("=");
            var aaa = tmp1[1];

            if (tmp1[0].indexOf("size") != -1) {
                if (sizes == "")
                    sizes = tmp1[1];
                else
                    sizes = sizes + "," + tmp1[1];
            } else {
                if (tmp1[0] === 'sort_by' || tmp1[0] === 'sort' ) {
                    sort_by = aaa;
                } else if (aaa) {
                    if (filter_string == "")
                        filter_string = aaa;
                    else
                        filter_string = filter_string + "+" + aaa;
                }
            }
            if (test[i].indexOf("sort_by") != -1) {
                sort = test[i];
            }
        }
        //debugger;

        var url = ((window.collection_url != '' || typeof window.collection_url != 'undefined') ? window.collection_url : '') + '/';

        url = url + filter_string;

        if (sort == "")
            url = url + "?view=custom-filter";
        else
            url = url + "?" + sort + "&view=custom-filter";

        if ($bypass == true && (filter_string || sort)) {
            $("#product_listing").empty();
        } else if ($bypass == true && data != '') {
            return;
        }

        if (sizes || sizeValue) {
            let param = sizeValue ? sizeValue : sizes;
            if(sizes){
                const size_string = sizes ? sizes.split(",") : [];
                for (const size of size_string) {
                    url = url + "&filter.v.option.size=" + size.replace("size_", "");
                }
            } else {
                url = url + "&filter.v.option.size=" + param;
            }
        }

        $.get(url, function (data, status, xhr) {
            var filtered_html = short_desktop_data(data.replace(/^\s+|\s+$/gm, ''), '');

            var temp = document.createElement('div');
            temp.innerHTML = filtered_html;

            $("#filter").find('.selected_filter').replaceWith($(temp).find('.selected_filter'));
            $("#product_listing").html(filtered_html).find('.selected_filter').remove();
        });

        return false;
    }
}

function filter_mobile_data($bypass, sizeValue = null) {
    //var data = $("#collection-filters-drawer-data").serialize();
    var data = sizeValue ? "" : $("#collection-filters-drawer-data").serialize();
    if (data == "" && !$bypass) {
        return false;
    } else {
        var sort = "";
        var test = data.split("&");
        var filter_string = "";
        var sort_by = '';
        var sizes = '';
        for (var i = 0; i < test.length; i++) {
            var tmp1 = test[i].split("=");
            var aaa = tmp1[1];

            if (tmp1[0].indexOf("size") != -1) {
                if (sizes == "")
                    sizes = tmp1[1];
                else
                    sizes = sizes + "," + tmp1[1];
            } else {
                if (tmp1[0] === 'sort_by') {
                    sort_by = aaa;
                } else if (aaa) {
                    if (filter_string == "")
                        filter_string = aaa;
                    else
                        filter_string = filter_string + "+" + aaa;
                }
            }

            if (test[i].indexOf("sort_by") != -1) {
                sort = test[i];
            }
        }

        var url = window.collection_url + "/";
        url = url + filter_string;

        if (sort == "")
            url = url + "?view=custom-filter";
        else
            url = url + "?" + sort + "&view=custom-filter";

        if ($bypass == true && (filter_string || sort)) {
            $("#product_listing").empty();
        } else if ($bypass == true) {
            return;
        }

        if (sizes || sizeValue) {
            let param = sizeValue ? sizeValue : sizes;
            if(sizes){
                const size_string = sizes ? sizes.split(",") : [];
                for (const size of size_string) {
                    url = url + "&filter.v.option.size=" + size.replace("size_", "");
                }
            } else {
                url = url + "&filter.v.option.size=" + param;
            }
        }

        $.get(url, function (data, status, xhr) {
            var filtered_html = short_desktop_data(data.replace(/^\s+|\s+$/gm, ''), '');

            var temp = document.createElement('div');
            temp.innerHTML = filtered_html;

            $("#filter").find('.selected_filter').replaceWith($(temp).find('.selected_filter'));
            $("#product_listing").html(filtered_html).find('.selected_filter').remove();
            // $("#product_listing").html(data).find('.selected_filter').remove();
        });
    }
}

$(document).ready(function() {

    if (
        typeof performance != 'undefined' &&
        typeof performance.navigation != 'undefined' &&
        typeof performance.navigation.type != 'undefined' &&
        performance.navigation.type == 2 &&
        $(window).width() > 1139
    ) {
        setTimeout(function() {
            var data = $("#filter").serialize();
            if (data) {
                filter_data();
            }
        }, 50 );
    }

    if (
        typeof performance != 'undefined' &&
        typeof performance.navigation != 'undefined' &&
        typeof performance.navigation.type != 'undefined' &&
        performance.navigation.type == 2 &&
        $(window).width() < 1140
    ) {
        var data = $("#collection-filters-drawer-data").serialize();
        var currentUrl = new URL(location.href);
        var sort_by = currentUrl.searchParams.get('sort_by');
        if (!sort_by) {
            sort_by = 'manual';
        }
        data = data.replace('sort_by=' + sort_by, '');
        if (data) {
            filter_mobile_data();
        }
    }

    if (window.collection_url != '' || typeof window.collection_url != 'undefined') {
        $(document).on("click", ".btn_submit:not(.filter_sort)", function (e) {
            e.preventDefault();
            filter_data(false);

            $('.filter_holder').removeClass('change--bg');
            return false;
        });

        $(document).on("click", ".btn_submit.filter_sort", function(e) {
            e.preventDefault();
            var filter_sort = $('#filter [name="sort"]:checked').val();
            if (!filter_sort) {
                $($('#filter [name="sort"]').get(0)).trigger('click');
            }

            filter_sort = $('#filter [name="sort"]:checked').val();

            var html = short_desktop_data($(".CollectionInner__Products .ProductListWrapper").html(), filter_sort);
            $(".CollectionInner__Products .ProductListWrapper").html(html);
            $(".loading_more").attr('href', window.collection_url + '?page=1000');
            $(".loading_more").hide();
            jQuery('.filter_holder .inner-label').removeClass('sub--open');
            $('.filter_holder').removeClass('change--bg');
            return false;
        });

        $(document).on("click", ".selected_filter a:not(.clear_all)", function(e) {
            e.preventDefault();
            var url = $(this).attr('href');

            if ($(this).hasClass('clear_all')) {
                return true;
            } else if ($(this).attr('data-tag') != '') {
                $('#filter').find('input[value="' + $(this).attr('data-tag') + '"]').prop('checked', false);
                if (url == 'javascript:;') {
                    var data = $("#filter").serialize();
                    if (data == '') {
                        window.location = $(document).find('.selected_filter a.clear_all').attr('href');
                    } else {
                        filter_data(data == '');
                    }
                    return false;
                }
            }

            $.get(url, function(data, status, xhr) {
                //alert(data.indexOf("No Filter Selected."));
                if (data.indexOf("No Filter Selected.") != -1) {
                    location.reload();
                    return false;
                }

                var filtered_html = short_desktop_data(data.replace(/^\s+|\s+$/gm, ''), '');

                var temp = document.createElement('div');
                temp.innerHTML = filtered_html;
                $("#filter").find('.selected_filter').replaceWith($(temp).find('.selected_filter'));
                $("#product_listing").html(filtered_html).find('.selected_filter').remove();
            });


            return false;
        });

        jQuery(document).on('click', '.filter_holder .inner-label', function() {
            if ($(this).hasClass('sub--open')) {
                jQuery('.filter_holder').removeClass('change--bg');
                jQuery('.filter_holder .inner-label').removeClass('sub--open');
            } else {
                jQuery('.filter_holder').removeClass('change--bg');
                jQuery('.filter_holder .inner-label').removeClass('sub--open');
                jQuery(this).addClass('sub--open');
                jQuery(this).parents('.filter_holder').addClass('change--bg');
            }
        });

        $('#collection-filters-drawer-data .apply-filter[data-action="close-drawer"]').on("click", function (e) {
            e.preventDefault();
            var data = $("#collection-filters-drawer-data").serialize();
            var currentUrl = new URL(location.href);
            var sort_by = currentUrl.searchParams.get('sort_by');
            if( !sort_by ) {
                sort_by = 'manual';
            }
            data = data.replace('sort_by=' + sort_by, '');
            if (data == '') {
                window.location = location.href;
                $('#collection-filter-drawer .Drawer__Close').trigger('click');
                return false;
            } else {
                filter_mobile_data(false );
                $('#collection-filter-drawer .Drawer__Close').trigger('click');
                return false;
            }
        });

        $('#collection-filters-sidebar .Linklist__Checkbox').on("change", function (e) {
            e.preventDefault();
            filter_mobile_data(false);
            return false;
        });
    }
});

function updateCarouselHeights() {
    var slideShowElements = document.querySelectorAll('[data-flickity-config]');
    if( slideShowElements ) {
        slideShowElements.forEach(function (element) {
            var flkty = Flickity.data(element);
            if (flkty) {
                var maxHeight = 0;

                // Get the height of the currently active slide
                var activeSlide = flkty.selectedElement;
                if (activeSlide) {
                    maxHeight = activeSlide.offsetHeight;
                }

                // Update the height of the Flickity viewport
                element.querySelector('.flickity-viewport').style.height = maxHeight + 'px';
            }
        });
    }
}

// Call on resize and after initialization
window.addEventListener('resize', updateCarouselHeights);
updateCarouselHeights();

document
  .querySelectorAll(".attentive-link-subscribe, .attentive-signup")
  .forEach((element) => {
    element.addEventListener("click", function (e) {
      e.preventDefault();
      if (window.innerWidth >= 760) {
        window.__attentive.trigger(null, null, null, 1124058);
      } else {
        window.__attentive.trigger(null, null, null, 1124059);
      }
    });
  });